import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const state = {
    otherFrom: true,
    name: '',
    headfresh: false,
    employeeFresh: false,
    open: false
}

const getters = {}

const mutations = {
    setOtherFrom(state, {boo, name}) {
        state.otherFrom = boo
        state.name = ''
        state.name = name
    },
    setFresh(state, {data}) {
        state.headfresh = data
    },
    setEmployeeFresh(state, {data}) {
        state.employeeFresh = data
    },
    openDashboard(state) {
        state.open = true
    },
    closeDashboard(state) {
        state.open = false
    },
}

const actions = {}

export default new Vuex.Store ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/store/index.js